import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import PriceChangeTracker from './components/PriceChangeTracker';

const priceChangeTracker = (props, { t }) => (
  <Container>
    <PriceChangeTracker {...props} />
  </Container>
);

priceChangeTracker.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(priceChangeTracker);
